import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './Hero';
import Philosophy from './Philosophy';
import Services from './Services';
import Contact from './Contact';
import SEO from './SEO';

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle hash scrolling (e.g., /#contact)
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <SEO />
      <Hero />
      <Philosophy />
      <Services />
      <Contact />
    </>
  );
};

export default Home;